import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  TextField,
  Typography,
} from "@mui/material";
import { ExpandMore } from "@mui/icons-material";

export default function EditHeader({ editDrawerState }) {
  const { grid, handleGridChange } = editDrawerState;

  return (
    <div>
      <Accordion
        defaultExpanded={true}
        sx={{
          boxShadow: "none",
          "& .Mui-expanded": { marginBottom: "0px" },
          width: "100%",
        }}
      >
        <AccordionSummary
          sx={{ maxHeight: "30px", width: "100%", padding: "0px" }}
          expandIcon={<ExpandMore />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography
            style={{
              fontFamily: "Inter",
              fontSize: "14px",
              fontWeight: "500",
              color: "#000000",
            }}
          >
            Edit Header Title
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <TextField
            sx={{
              "& legend": { display: "none" },
              "& fieldset": { top: 0 },
            }}
            placeholder="Enter Title"
            style={{ width: "100%" }}
            id="outlined-basic"
            defaultValue={grid.title}
            onChange={(e) => handleGridChange("title", e.target.value, grid.id)}
            variant="outlined"
            size="small"
          />
        </AccordionDetails>
      </Accordion>
      <Accordion
        defaultExpanded={true}
        sx={{
          boxShadow: "none",
          "& .Mui-expanded": { marginBottom: "0px" },
          width: "100%",
        }}
      >
        <AccordionSummary
          sx={{ maxHeight: "30px", width: "100%", padding: "0px" }}
          expandIcon={<ExpandMore />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography
            style={{
              fontFamily: "Inter",
              fontSize: "14px",
              fontWeight: "500",
              color: "#000000",
            }}
          >
            Edit Sub-Header Title
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <TextField
            sx={{
              "& legend": { display: "none" },
              "& fieldset": { top: 0 },
            }}
            placeholder="Enter Title"
            style={{ width: "100%" }}
            id="outlined-basic"
            defaultValue={grid.subtitle}
            onChange={(e) =>
              handleGridChange("subtitle", e.target.value, grid.id)
            }
            variant="outlined"
            size="small"
          />
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
